<template>
  <el-table class="common-el-table-styles" border stripe :data="data" :height="height" @selection-change="handleSelectionChange">
    <slot name="selection">
      <el-table-column type="selection" width="39"> </el-table-column>
    </slot>
    <el-table-column
      v-for="(col, id) in columns"
      :key="id"
      :prop="col.key"
      :label="col.title"
      :show-overflow-tooltip="col.overflow"
      :min-width="col.width"
      :align="col.align"
    >
      <template #default="{ row }">
        <div v-if="col.key === 'control'">
          <el-button type="text" @click="$emit('edit', row)">修改</el-button>
          <el-button type="text" @click="$emit('del', row)">删除</el-button>
        </div>
        <span v-else-if="col.key === 'content'">
          <slot name="content" :row="row"></slot>
        </span>
        <template v-else-if="col.key === 'relatedMaterialsNum'">
          <slot name="related-materials" :row="row"></slot>
        </template>

        <span v-else-if="col.key === 'gameNames'">{{ nullFormat(row[col.key]) }}</span>
        <span v-else>{{ row[col.key] }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script setup>
import { datetimeToSec, nullFormat } from '@/common/js/filters'
// eslint-disable-next-line
const props = defineProps({
  data: {
    type: Array,
    default: () => []
  },
  columns: {
    type: Array
  },
  height: {
    type: Number
  }
})
// eslint-disable-next-line
const emit = defineEmits(['edit', 'del', 'select'])
const handleSelectionChange = (val) => {
  emit('select', val)
}
</script>
